import { lazy } from "react";

export const retry = async (
  // tslint:disable-next-line: no-any
  fn: () => any,
  retriesLeft: number = 6,
  interval: number = 2500
  // tslint:disable-next-line: no-any
): Promise<any> =>
  // tslint:disable-next-line: typedef
  new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      // tslint:disable-next-line: no-any
      .catch((error: any) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            return resolve(
              import(
                /* webpackChunkName: "ErrorComponent" */
                /* webpackMode: "eager" */
                "../../pages/Error"
              )
            );
          }
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

export const Home = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Home" */
      "../../pages/Home"
    )
  )
);

export const KitchenSink = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "KitchenSink" */
      "../../pages/KitchenSink"
    )
  )
);

export const StoreLocatorPage = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "StoreLocatorPage" */
      "../../pages/StoreLocatorPage"
    )
  )
);

export const StoreData = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "StoreData" */
      "../../pages/StoreLocatorPage/StoreDataPage"
    )
  )
);

export const NewArrivals = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "NewArrivals" */
      "../../pages/NewArrivals"
    )
  )
);
export const GiftCard = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "GiftCard" */
      "../../pages/GiftCard"
    )
  )
);

export const MerchantGiftOperation = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "MerchantGiftOperation" */
      "../../pages/MerchantGiftOperation"
    )
  )
);

export const Alphabetic = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Alphabetic" */
      "../../pages/Alphabetic"
    )
  )
);

export const Checkout = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Checkout" */
      "../../pages/OrderFunnel/Checkout"
    )
  )
);

export const Authentication = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Authentication" */
      "../../pages/OrderFunnel/Authentication"
    )
  )
);

export const OrderConfirmation = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "OrderConfirmation" */
      "../../pages/OrderFunnel/OrderConfirmation"
    )
  )
);

export const Payment = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Payment" */
      "../../pages/OrderFunnel/Payment"
    )
  )
);

export const PaymentRedirect = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "PaymentRedirect" */
      "../../pages/OrderFunnel/PaymentRedirect"
    )
  )
);

export const Shipping = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Shipping" */
      "../../pages/OrderFunnel/Shipping"
    )
  )
);

export const AddressesEdition = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "AddressesEdition" */
      "../../pages/OrderFunnel/Shipping/AddressesEdition"
    )
  )
);

export const Search = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Search" */
      "../../pages/Search"
    )
  )
);

export const AccountCreation = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "AccountCreation" */
      "../../pages/AccountCreation"
    )
  )
);

export const AccountLogin = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "AccountLogin" */
      "../../pages/AccountLogin"
    )
  )
);

export const CMS = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "CMS" */
      "../../pages/CMS"
    )
  )
);

export const NotFound = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "NotFound" */
      "../../pages/NotFound"
    )
  )
);

export const Category = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Category" */
      "../../pages/Category"
    )
  )
);

export const Product = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Product" */
      "../../pages/Product"
    )
  )
);

export const Footer = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "Footer" */
      "../../components/Pages/Page/components/Footer"
    )
  )
);
